import React from "react";
import { Play, Video } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function VideosSection() {
  const { artist, setActiveVideo } = useApp();

  return (
    <section className="px-5 pt-8">
      <div className="flex items-center gap-2 mb-4">
        <span className="section-dot bg-red-500" />
        <h2 className="text-[13px] font-semibold tracking-[0.16em] uppercase text-white">Videos</h2>
        <span className="text-[11px] text-white/35">{artist.videos.length} clips</span>
      </div>

      <div className="flex gap-3 overflow-x-auto no-scrollbar -mx-1 px-1 pb-1">
        {artist.videos.map((v) => (
          <button
            key={v.id}
            onClick={() => setActiveVideo(v)}
            className="relative shrink-0 w-[240px] aspect-video rounded-xl overflow-hidden group"
          >
            <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="flex items-center justify-center w-12 h-9 rounded-lg bg-red-600 shadow-lg transition-transform group-hover:scale-105">
                <Play size={18} className="text-white ml-0.5" fill="white" />
              </span>
            </span>
            <span className="absolute bottom-2 left-2.5 right-2.5 text-left text-[12px] font-medium text-white drop-shadow truncate">
              {v.title}
            </span>
          </button>
        ))}
        {artist.videos.length === 0 && (
          <div className="flex items-center gap-2 text-white/40 text-sm py-6">
            <Video size={16} /> No videos yet.
          </div>
        )}
      </div>
    </section>
  );
}
